import { ListItemButton, ListItemText, Checkbox } from "@mui/material"
import PropTypes from "prop-types"
import { MetricTypeOptionShape } from "./helpers/prop-types"

export default function MetricType({
  option,
  toggleSelectedMetricColumn,
  disableOptions,
  subcategoryType,
  itemId,
}) {
  const isDisabled = !option.selected && disableOptions
  const label = `${option.label} (${option.unit})`

  return <ListItemButton
    disabled={isDisabled}
    classes={{ root: "list-item" }}
    className="metrics-type"
    onClick={() => toggleSelectedMetricColumn(subcategoryType, itemId, option.id)}
  >
    <Checkbox
      color="primary"
      className="metrics-checkbox"
      // Need to set tabIndex to -1 because the parent element is a button that controls the checkbox state
      tabIndex={-1}
      checked={option.selected}
      disableRipple
      disabled={isDisabled}
    />
    <ListItemText>{label}</ListItemText>
  </ListItemButton>
}

MetricType.propTypes = {
  option: MetricTypeOptionShape.isRequired,
  toggleSelectedMetricColumn: PropTypes.func.isRequired,
  disableOptions: PropTypes.bool.isRequired,
  subcategoryType: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
}
